<template>
  <div class="meeting-mobile">
    <div class="meeting-mobile__header">
      <h1 class="meeting-mobile__header-title">{{ vacancy_title }}</h1>
      <div class="meeting-mobile__header-meeting">
        <p class="meeting-mobile__header-date">
          {{ `${dayOfWeek}/${monthAndYer}` }}
        </p>
        <p class="meeting-mobile__header-time">{{ time }}</p>
      </div>
    </div>
    <div class="meeting-mobile__content">
      <p class="meeting-description--markedby">
        <vs-icon icon="person" />Entrevista marcada por {{ scheduledBy }}
      </p>
      <p class="meeting-description--address">
        <vs-icon icon="room" />{{ place }}
      </p>
      <p v-if="onShowDescription()" class="meeting-description--message">
        <vs-icon class="mr-1" icon="mode_comment" /> {{ description }}
        <a v-if="showMore" @click="moreDescription">{{
          `${!fullDescription ? "ver mais" : "ver menos"}`
        }}</a>
      </p>
      <div>
        <div v-if="waiting" class="meeting-actions">
          <div class="meeting-actions--fullarea">
            <vs-button
              class="min-w-full"
              icon="check_circle"
              color="#9B27B0"
              type="filled"
              @click="accept_proposal_popup = true"
            >
              Aceitar Reunião
            </vs-button>
          </div>
          <div class="meeting-actions--dividearea">
            <vs-button
              size="small"
              icon="query_builder"
              color="#9B27B0"
              type="border"
              @click="time_sugest_popup = true"
            >
              Sugerir Horário
            </vs-button>
            <vs-button
              size="small"
              icon="thumb_down"
              color="#9B27B0"
              type="border"
              class="ml-2"
              @click="reject_proposal_popup = true"
            >
              Rejeitar Proposta
            </vs-button>
          </div>
        </div>
        <div v-else class="meeting-actions">
          <div class="meeting--label" :class="status_class">{{ status }}</div>
          <span class="meeting--label__description">
            {{ status_message }}
          </span>
        </div>
      </div>
    </div>

    <vs-popup title="Aceitar Proposta" :active.sync="accept_proposal_popup">
      <vs-row>
        <vs-col
          class="mb-8"
          vs-type="flex"
          vs-align="center"
          vs-justify="start"
          vs-w="12"
        >
          <p>Deseja aceitar a proposta?</p>
        </vs-col>
        <vs-col
          class="px-0 flex-row-reverse"
          vs-type="flex"
          vs-align="center"
          vs-justify="end"
          vs-w="12"
        >
          <vs-button
            class="mx-1"
            @click="onAccept"
            color="primary"
            type="filled"
          >
            Aceitar
          </vs-button>
          <vs-button
            class="mx-1"
            @click="accept_proposal_popup = false"
            color="dark"
            type="flat"
          >
            Cancelar
          </vs-button>
        </vs-col>
      </vs-row>
    </vs-popup>

    <vs-popup title="Recusar Proposta" :active.sync="reject_proposal_popup">
      <vs-row>
        <vs-col
          class="mb-8"
          vs-type="flex"
          vs-align="center"
          vs-justify="end"
          vs-w="12"
        >
          <p>Deseja recusar a proposta?</p>
        </vs-col>
        <vs-col class="mb-2 flex-col" vs-w="12" vs-type="flex">
          <label for="">Observações</label>
          <vs-textarea
            placeholder="Olá estou recusando a proposta pois ..."
            counter="120"
            v-model="talent_response"
          />
        </vs-col>
        <vs-col
          class="px-0 flex-row-reverse"
          vs-type="flex"
          vs-align="center"
          vs-justify="end"
          vs-w="12"
        >
          <vs-button
            class="mx-1"
            @click="onReject"
            color="danger"
            type="filled"
          >
            Recusar
          </vs-button>
          <vs-button
            class="mx-1"
            @click="reject_proposal_popup = false"
            color="dark"
            type="flat"
          >
            Cancelar
          </vs-button>
        </vs-col>
      </vs-row>
    </vs-popup>

    <vs-popup title="Sugerir Horário" :active.sync="time_sugest_popup">
      <vs-row>
        <vs-col
          class="mb-2"
          vs-type="flex"
          vs-align="center"
          vs-justify="end"
          vs-w="12"
        >
          <p>Deseja sugerir um novo horário?</p>
        </vs-col>
        <vs-col class="mb-6" vs-w="6">
          <vs-input
            class="mt-0 mr-2 w-full"
            name="birthday"
            type="tel"
            label="Data*"
            v-mask="'##/##/####'"
            v-validate="'required|birthday'"
            data-vv-validate-on="blur"
            placeholder="'ex. 00/00/0000'"
            v-model="date_sugest"
          />
          <span class="text-danger text-sm">{{
            errors.first("birthday")
          }}</span>
        </vs-col>
        <vs-col class="mb-6" vs-w="6">
          <vs-input
            icon-pack="feather"
            icon="icon-clock"
            label="Horário"
            placeholder="ex. 00:00"
            v-model="time_sugest"
            type="tel"
            v-mask="`##:##`"
            class="mt-0 mr-2 w-full"
          />
        </vs-col>
        <vs-col class="mb-2 flex-col" vs-w="12" vs-type="flex">
          <label for="">Motivo</label>
          <vs-textarea
            placeholder="Olá estou sugerindo um novo horário pois ..."
            counter="120"
            v-model="talent_response"
          />
        </vs-col>
        <vs-col
          class="px-0 flex-row-reverse"
          vs-type="flex"
          vs-align="center"
          vs-justify="end"
          vs-w="12"
        >
          <vs-button
            class="mx-1"
            @click="onTimeSugest"
            color="primary"
            type="filled"
          >
            Sugerir
          </vs-button>
          <vs-button
            class="mx-1"
            @click="time_sugest_popup = false"
            color="dark"
            type="flat"
          >
            Cancelar
          </vs-button>
        </vs-col>
      </vs-row>
    </vs-popup>
  </div>
</template>

<script>
import {
  isSunday,
  isMonday,
  isTuesday,
  isWednesday,
  isThursday,
  isFriday,
  isSaturday,
} from "date-fns";

export default {
  name: "meeting-mobile-card",
  props: {
    waiting: {
      type: Boolean,
      required: true,
    },
    meeting: {
      type: Object,
    },
  },
  created() {
    this.$validator.extend("birthday", {
      getMessage: (field, params, data) =>
        (data && data.message) || "Erro não encontrado",
      validate: (value) => {
        return new Promise((resolve) => {
          const splitDate = value.split("/");

          const dayReg = /(0[1-9]|[12]\d|3[01])/;
          const monthReg = /0[1-9]|1[0-2]/;
          const yearReg = /(?:(?:19|20)[0-9]{2})/;

          if (!splitDate[0].match(dayReg))
            resolve({
              valid: false,
              data: {
                message: `O dia ${splitDate[0]} informado não é válido!`,
              },
            });
          if (!splitDate[1].match(monthReg))
            resolve({
              valid: false,
              data: {
                message: `O mês ${splitDate[1]} informado não é válido!`,
              },
            });
          if (!splitDate[2].match(yearReg))
            resolve({
              valid: false,
              data: {
                message: `O ano ${splitDate[2]} informado não é válido!`,
              },
            });

          resolve({ valid: true, data: "" });
        });
      },
    });
  },
  data() {
    return {
      date_sugest: "",
      time_sugest: "",
      talent_response: "",
      fullDescription: false,
      time_sugest_popup: false,
      accept_proposal_popup: false,
      reject_proposal_popup: false,
    };
  },
  computed: {
    textualDayOfWeek() {
      let textualWeekDay = "";

      if (this.meeting != undefined && this.meeting.hasOwnProperty("date")) {
        const splited = this.meeting.date.split("/");
        const date = new Date(splited[2], parseInt(splited[1]) - 1, splited[0]);

        if (isSunday(date)) {
          textualWeekDay = "Domingo";
        }
        if (isMonday(date)) {
          textualWeekDay = "Segunda";
        }
        if (isTuesday(date)) {
          textualWeekDay = "Terça";
        }
        if (isWednesday(date)) {
          textualWeekDay = "Quarta";
        }
        if (isThursday(date)) {
          textualWeekDay = "Quinta";
        }
        if (isFriday(date)) {
          textualWeekDay = "Sexta";
        }
        if (isSaturday(date)) {
          textualWeekDay = "Sábado";
        }
      }
      return textualWeekDay;
    },

    dayOfWeek() {
      if (this.meeting != undefined && this.meeting.hasOwnProperty("date")) {
        const splited = this.meeting.date.split("/");
        return splited[0];
      }
      return "";
    },

    monthAndYer() {
      if (this.meeting != undefined && this.meeting.hasOwnProperty("date")) {
        const splited = this.meeting.date.split("/");
        const date = new Date(splited[2], parseInt(splited[1]) - 1, splited[0]);

        return date
          .toLocaleString("pt-BR", { month: "long" })
          .slice(0, 3)
          .toUpperCase()
          .concat("/")
          .concat(`${date.toLocaleString("pt-BR", { year: "numeric" })}`);
      }
      return "";
    },

    time() {
      return this.meeting != undefined && this.meeting.hasOwnProperty("time")
        ? this.meeting.time.slice(0, 5)
        : "";
    },

    place() {
      return this.meeting != undefined && this.meeting.hasOwnProperty("place")
        ? this.meeting.place
        : "";
    },

    status() {
      return this.meeting != undefined &&
        this.meeting.hasOwnProperty("meeting_status")
        ? this.meeting.meeting_status["description"]
        : "";
    },

    status_message() {
      return this.meeting != undefined &&
        this.meeting.meeting_status_id == 1 &&
        this.meeting.hasOwnProperty("meeting_status_id")
        ? "Compareça no local e hora indicados"
        : "Esperando o aceite do horário sugerido";
    },

    status_class() {
      return this.meeting != undefined &&
        this.meeting.meeting_status_id == 1 &&
        this.meeting.hasOwnProperty("meeting_status")
        ? "meeting--label__success"
        : "meeting--label__alert";
    },

    meeting_type_description() {
      return this.meeting != undefined &&
        this.meeting.hasOwnProperty("meeting_type")
        ? this.meeting.meeting_type["description"]
        : "";
    },

    vacancy_title() {
      return this.meeting !== undefined &&
        this.meeting !== null &&
        this.meeting.hasOwnProperty("vacancy") &&
        this.meeting.vacancy !== null
        ? this.meeting.vacancy["title"]
        : "Sem título";
    },

    scheduledBy() {
      return this.meeting != undefined && this.meeting.hasOwnProperty("manager")
        ? this.meeting.manager["user"].name
        : "";
    },

    description() {
      if (this.meeting != undefined && this.meeting.hasOwnProperty("comment")) {
        if (!this.fullDescription) return this.meeting.comment.slice(0, 184);
        return this.meeting.comment;
      }
      return "";
    },

    showMore() {
      if (this.meeting != undefined && this.meeting.hasOwnProperty("comment")) {
        return this.meeting.comment.length > 184;
      }
    },
  },

  methods: {
    onShowDescription() {
      return (
        this.meeting !== undefined &&
        this.meeting.hasOwnProperty("comment") &&
        this.meeting.comment != null
      );
    },

    moreDescription() {
      this.fullDescription = !this.fullDescription;
    },

    onAccept() {
      const LABEL = localStorage.getItem("label");

      this.accept_proposal_popup = false;
      this.$vs.loading({
        text: "Enviando...",
      });

      this.$http
        .put(
          `/api/v1/talent/${LABEL}/user/talent/meetings/${this.meeting.id}/answer`,
          { talent_response: "Ok, Confirmado", meeting_status_id: 1 }
        )
        .then(() => {
          this.$vs.loading.close();
          this.waiting = false;
          this.meeting = Object.assign({}, this.meeting, {
            meeting_status_id: 1,
          });
          this.meeting.meeting_status = Object.assign(
            {},
            this.meeting.meeting_status,
            { description: "Aprovado" }
          );
          this.$vs.notify({
            text: "A sua resposta foi enviada com sucesso para o gestor!",
            title: "Reunião Aceita!",
            icon: "icon-alert-circle",
            color: "success",
            iconPack: "feather",
            time: 5000,
          });
          // PostHog: meeting proposal accepted
          (async () => {
            try {
              const { trackEvent } = await import("@/services/posthog");
              trackEvent("meeting_proposal_accepted", {
                meeting_id: this.meeting && this.meeting.id,
                vacancy_title: this.vacancy_title,
                meeting_type: this.meeting_type_description,
                place: this.place,
                time: this.time,
              });
            } catch (_) {}
          })();
        })
        .catch(() => {
          this.$vs.loading.close();
          this.$vs.notify({
            text: "Ocorreu uma falha, tente realizar o procedimento novamente",
            title: "Opps!",
            icon: "icon-alert-circle",
            color: "warning",
            iconPack: "feather",
            time: 5000,
          });
        });
    },

    onReject() {
      const LABEL = localStorage.getItem("label");

      this.$vs.loading({
        text: "Enviando...",
      });

      this.$http
        .put(
          `/api/v1/talent/${LABEL}/user/talent/meetings/${this.meeting.id}/answer`,
          { talent_response: this.talent_response, meeting_status_id: 2 }
        )
        .then((response) => {
          this.$vs.loading.close();
          this.reject_proposal_popup = false;
          this.waiting = false;
          this.meeting = Object.assign({}, this.meeting, {
            meeting_status_id: 2,
          });
          this.meeting.meeting_status = Object.assign(
            {},
            this.meeting.meeting_status,
            { description: "Rejeitada" }
          );
          this.$vs.notify({
            text: "A sua resposta foi enviada com sucesso para o gestor!",
            title: "Reunião Rejeitada!",
            icon: "icon-alert-circle",
            color: "success",
            iconPack: "feather",
            time: 5000,
          });
          // PostHog: meeting proposal rejected
          (async () => {
            try {
              const { trackEvent } = await import("@/services/posthog");
              trackEvent("meeting_proposal_rejected", {
                meeting_id: this.meeting && this.meeting.id,
                vacancy_title: this.vacancy_title,
                meeting_type: this.meeting_type_description,
                place: this.place,
                time: this.time,
                talent_response: this.talent_response || null,
              });
            } catch (_) {}
          })();
        })
        .catch((error) => {
          this.$vs.loading.close();
          this.reject_proposal_popup = false;
          this.$vs.notify({
            text: "Ocorreu uma falha, tente realizar o procedimento novamente",
            title: "Opps!",
            icon: "icon-alert-circle",
            color: "warning",
            iconPack: "feather",
            time: 5000,
          });
        });
    },

    onTimeSugest() {
      const LABEL = localStorage.getItem("label");

      this.time_sugest_popup = false;
      this.$vs.loading({
        text: "Enviando...",
      });

      this.$http
        .put(
          `/api/v1/talent/${LABEL}/user/talent/meetings/${this.meeting.id}/answer`,
          {
            talent_response: this.talent_response,
            meeting_status_id: 3,
            suggested_date: this.date_sugest
              .replace(/\//g, "-")
              .concat(` ${this.time_sugest}:00`),
          }
        )
        .then((response) => {
          this.$vs.loading.close();
          this.waiting = false;
          this.meeting = Object.assign({}, this.meeting, {
            meeting_status_id: 3,
          });
          this.meeting.meeting_status = Object.assign(
            {},
            this.meeting.meeting_status,
            {
              description: "Aguardando Ação do Gestor",
              time: this.time_sugest.concat(`:00`),
              date: this.date_sugest,
            }
          );
          this.$vs.notify({
            text: "A sua sugestão foi enviada com sucesso para o gestor!",
            title: "Sugestão de horário!",
            icon: "icon-alert-circle",
            color: "success",
            iconPack: "feather",
            time: 5000,
          });
        })
        .catch((error) => {
          this.$vs.loading.close();
          this.$vs.notify({
            text: "Ocorreu uma falha, tente realizar o procedimento novamente",
            title: "Opps!",
            icon: "icon-alert-circle",
            color: "warning",
            iconPack: "feather",
            time: 5000,
          });
        });
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/talent/components/meetingmobilecard.scss";
</style>
